import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import { Neubla } from '../nebula-class';
import upAlbumModule from './upAlbumModule';
import upAlipayModule from './upAlipayModule';
import upAudioRecorderModule from './upAudioRecorderModule';
import bindModule from './bindModule';
import upBleModule from './upBleModule';
import upDeviceModule from './upDeviceModule';
import upFamilyModule from './upFamilyModule';
import upHttpModule from './upHttpModule';
import upImageModule from './upImageModule';
import upInfraredModule from './upInfraredModule';
import upLiveModule from './upLiveModule';
import upLocationModule from './upLocationModule';
import upLogicEngineModule from './upLogicEngineModule';
import upMakeSignModule from './upMakeSignModule';
import upNetworkModule from './upNetworkModule';
import upOSSModule from './upOssModule';
import upPedometerModule from './upPedometerModule';
import upPermissionModule from './upPermissionModule';
import upRequestModule from './upRequestModule';
import upResourceModule from './upResourceModule';
import upShareModule from './upShareModule';
import upSpeechRecognitionModule from './upSpeechRecognitionModule';
import upSystemModule from './upSystemModule';
import upUserModule from './upUserModule';
import upVdnModule from './upVdnModule';
import upWeiXinModule from './upWeiXinModule';
import upWifiModule from './upWifiModule';
import upBindConfigModule from './upBindConfigModule';
import upDiscoverDeviceModule from './upDiscoverDeviceModule';
import upNetworkConfigModule from './upNetworkConfigModule';
import upAlexaAuthModule from './upAlexaAuthModule';
import upUSDKFOTAModule from './upUSDKFOTAModule';
import upUnionPayModule from './upUnionPayModule';

var Uplus = function Uplus() {
    _classCallCheck(this, Uplus);

    if (!Uplus.instance) {
        Uplus.instance = new Neubla();
        Uplus.instance.extras = {
            upAlbumModule: upAlbumModule,
            upAlipayModule: upAlipayModule,
            upAudioRecorderModule: upAudioRecorderModule,
            bindModule: bindModule,
            upBleModule: upBleModule,
            upDeviceModule: upDeviceModule,
            upFamilyModule: upFamilyModule,
            upHttpModule: upHttpModule,
            upImageModule: upImageModule,
            upInfraredModule: upInfraredModule,
            upLiveModule: upLiveModule,
            upLocationModule: upLocationModule,
            upLogicEngineModule: upLogicEngineModule,
            upMakeSignModule: upMakeSignModule,
            upNetworkModule: upNetworkModule,
            upOSSModule: upOSSModule,
            upPedometerModule: upPedometerModule,
            upPermissionModule: upPermissionModule,
            upRequestModule: upRequestModule,
            upResourceModule: upResourceModule,
            upShareModule: upShareModule,
            upSpeechRecognitionModule: upSpeechRecognitionModule,
            upSystemModule: upSystemModule,
            upUserModule: upUserModule,
            upVdnModule: upVdnModule,
            upWeiXinModule: upWeiXinModule,
            upWifiModule: upWifiModule,
            upBindConfigModule: upBindConfigModule,
            upDiscoverDeviceModule: upDiscoverDeviceModule,
            upNetworkConfigModule: upNetworkConfigModule,
            upUSDKFOTAModule: upUSDKFOTAModule,
            upAlexaAuthModule: upAlexaAuthModule,
            upUnionPayModule: upUnionPayModule
        };
    }
    return Uplus.instance;
};

Uplus.instance = null;
export default Uplus;